module.exports = __webpack_public_path__ + "static/material-suede.a5b21c32.svg";